import { createStore } from '@stencil/store';
import { InitParamsState } from 'types';
import { getCookieValue } from 'utils/cookies';
import { isMobileBreakpoint } from 'utils/ui';
import { i18n } from 'i18n';

const { state, onChange, on, set, reset } = createStore<InitParamsState>({
  mode: 'FULL_SCREEN',
  isOffline: !navigator.onLine,
  pageViewId: 'undefined_pageviewid',
  sandbox: false,
  isApp: typeof getCookieValue('X-ClientInfo') !== 'undefined',
  domain: window.location.host,
  channel: '',
  locale: 'es',
  assistantId: '',
  isMobile: isMobileBreakpoint(),
});

onChange('locale', newValue => {
  if (!!newValue) {
    i18n.changeLanguage(newValue);
  }
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
